'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Button = _react2['default'].createClass({
    displayName: 'Button',


    propTypes: {
        'buttonText': _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.array]).isRequired,
        'buttonLink': _react2['default'].PropTypes.string,
        'buttonColor': _react2['default'].PropTypes.string,
        'buttonHoverColor': _react2['default'].PropTypes.string,
        'throbber': _react2['default'].PropTypes.bool,
        'buttonTextColor': _react2['default'].PropTypes.string,
        'buttonTextUppercase': _react2['default'].PropTypes.bool,
        'buttonLinkUsePost': _react2['default'].PropTypes.bool,
        'buttonLinkPostParams': _react2['default'].PropTypes.object,
        'buttonAttrs': _react2['default'].PropTypes.object,
        'buttonHoverTextColor': _react2['default'].PropTypes.string,
        'buttonHoverBorderColor': _react2['default'].PropTypes.string,
        'buttonBorderColor': _react2['default'].PropTypes.string,
        'buttonBorderWidth': _react2['default'].PropTypes.string,
        'buttonFont': _react2['default'].PropTypes.string,
        'buttonClass': _react2['default'].PropTypes.string,
        'buttonId': _react2['default'].PropTypes.string,
        'buttonModuleClass': _react2['default'].PropTypes.string,
        'buttonTabIndex': _react2['default'].PropTypes.any,
        'buttonMountPoint': _react2['default'].PropTypes.string,
        'type': _react2['default'].PropTypes.string,
        'wrapText': _react2['default'].PropTypes.bool,
        'buttonInner': _react2['default'].PropTypes.object,
        'iconUri': _react2['default'].PropTypes.string,
        'openInNewWindow': _react2['default'].PropTypes.bool,
        'disabled': _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            isProcessing: false
        };
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'buttonColor': 'ashen',
            'buttonHoverColor': 'castle-rock',
            'buttonTextColor': 'white',
            'buttonTextUppercase': true,
            'buttonModuleClass': '',
            'buttonTabIndex': 0,
            'type': '',
            'wrapText': false,
            'buttonLinkInNewWindow': false,
            'iconUri': null
        };
    },

    linkToLocation: function linkToLocation(evt) {

        if (this.props.throbber) {
            this.setState({ 'isProcessing': true });
        }
        document.location.href = this.props.buttonLink;

        // TODO: don't do this - users cannot ctrl+click a link and open a new
        // tab with this approach (CC)
        evt.preventDefault();
    },

    // TODO: Button should call onClick handler instead of handling service-level calls. (CC)
    submitAsPost: function submitAsPost(evt) {
        evt.preventDefault();
        var form = $(document.createElement('form')).attr('action', this.props.buttonLink).attr('method', 'POST');
        $('body').append(form);
        for (var i in this.props.buttonLinkPostParams) {
            if (this.props.buttonLinkPostParams.hasOwnProperty(i)) {
                var key = i;
                var value = this.props.buttonLinkPostParams[i];
            }
            $(document.createElement('input')).attr('type', 'hidden').attr('name', key).attr('value', value).appendTo(form);
        }
        $(form).submit();
    },

    componentDidMount: function componentDidMount() {
        if (this.props.buttonAttrs) {
            var node = this.props.openInNewWindow ? _reactDom2['default'].findDOMNode(this).firstElementChild : _reactDom2['default'].findDOMNode(this);
            for (var attr in this.props.buttonAttrs) {
                node.setAttribute(attr, this.props.buttonAttrs[attr]);
            }
        }

        if (this.props.throbber) {

            // TODO: remove? No idea where this is actually coming from. This sorta functionality
            // should be left up to the parent where the parent is setting 'isProcessing' explicitly (CC)
            $(document).bind('cancelProcessing', function () {
                this.setState({
                    'isProcessing': false
                });
            }.bind(this));
        }
    },

    render: function render() {
        var buttonColorClass = 'bg-' + this.props.buttonColor;
        var buttonHoverTextColorClass = this.props.buttonHoverTextColor ? 'hc-' + this.props.buttonHoverTextColor : '';
        var buttonBorderColorClass = this.props.buttonBorderColor ? 'border-' + (this.props.buttonBorderWidth ? this.props.buttonBorderWidth : '1') + '-' + this.props.buttonBorderColor : '';
        var buttonHoverBorderColorClass = this.props.buttonHoverBorderColor ? 'hborder-' + (this.props.buttonBorderWidth ? this.props.buttonBorderWidth : '1') + '-' + this.props.buttonHoverBorderColor : '';
        var buttonHoverColorClass = 'hbg-' + this.props.buttonHoverColor;
        var buttonTextColor = 'c-' + this.props.buttonTextColor;
        var buttonTextUppercase = this.props.buttonTextUppercase ? '' : 'm-button-normalcase';

        var buttonClasses = { 'm-button': true };

        if (typeof this.props.className != 'undefined') {
            buttonClasses[this.props.className] = true;
        }

        buttonClasses[buttonColorClass] = true;
        buttonClasses[this.props.buttonModuleClass] = true;
        buttonClasses[buttonHoverTextColorClass] = this.props.buttonHoverTextColor;
        buttonClasses[buttonBorderColorClass] = this.props.buttonBorderColor;
        buttonClasses[buttonHoverBorderColorClass] = this.props.buttonHoverBorderColor;
        buttonClasses[buttonHoverColorClass] = true;
        buttonClasses[buttonTextColor] = true;
        buttonClasses[buttonTextUppercase] = true;
        buttonClasses['progress-button'] = true;
        buttonClasses['state-loading'] = true;

        if (typeof this.props.buttonClass != 'undefined') {
            buttonClasses[this.props.buttonClass] = true;
        }

        buttonClasses['with-icon'] = this.props.iconUri !== null;

        var innerSpanClasses = (0, _classnames2['default'])({
            'l-nowrap': !this.props.wrapText
        });

        var throbber;
        var font = this.props.buttonFont ? { 'fontFamily': this.props.buttonFont } : {};
        if (this.props.throbber) {
            var throbberUrl = require('./transparent-throbber.gif');
            var throbberClassName = 'm-button-throbber';
            throbber = _jsx('img', {
                src: throbberUrl,
                className: throbberClassName,
                width: '16',
                height: '16'
            });
        }

        var inner;
        if (this.props.buttonInner) {
            inner = _jsx('span', {
                className: innerSpanClasses,
                style: font
            }, void 0, this.props.buttonInner);
        } else if (this.props.iconUri) {
            var iconUrl = _hfReactHelper2['default'].imgHelper(this.props.iconUri);
            inner = _jsx('span', {
                className: innerSpanClasses,
                style: font
            }, void 0, _jsx('img', {
                src: iconUrl,
                className: 'm-button--icon'
            }), this.props.buttonText);
        } else {
            inner = _jsx('span', {
                className: innerSpanClasses,
                style: font
            }, void 0, this.props.buttonText);
        }

        var hasButtonLink = this.props.buttonLink && typeof this.props.buttonLink === 'string';
        var handlerProvided = !!(this.props.onClick || this.state.onClick);

        // TODO: This has been refactored for clarity, but we still need to move the submit handler totally out of this
        // per (CC)'s comment above (DB)
        var onClick;
        if (!handlerProvided) {
            if (this.props.buttonLinkUsePost) {
                onClick = this.submitAsPost;
            } else if (hasButtonLink && this.props.openInNewWindow) {
                onClick = void 0; // Use native link logic
            } else if (hasButtonLink) {
                    onClick = this.linkToLocation; // Our specific link logic
                }
        } else {
                onClick = this.props.onClick || this.state.onClick;
            }

        var btn = _jsx('button', {
            className: (0, _classnames2['default'])(buttonClasses),
            onClick: onClick,
            id: this.props.buttonId,
            type: this.props.type,
            disabled: this.props.disabled,
            tabIndex: this.props.buttonTabIndex
        }, void 0, inner);

        if (this.props.openInNewWindow) {
            btn = _jsx('a', {
                href: this.props.buttonLink,
                target: '_blank'
            }, void 0, btn);
        }

        if (this.props.throbber && this.state.isProcessing) {
            return _jsx('div', {
                className: 'm-button-submit'
            }, void 0, throbber);
        } else {
            return btn;
        }
    }
});

module.exports = Button;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/button.jsx
 ** module id = 605
 ** module chunks = 0
 **/